import React, { useContext, useState } from "react";

import { ActiveFilterOptions } from "../ActiveFilterOptions/ActiveFilterOptions";
import { Check, Select } from "../filter-types";
import { SectionContainer } from "../../../../components/SectionContainer";
import { ResultCount } from "../ResultCount";
import { Button } from "../../../../components/Button";
import { SortSelect } from "../SortSelect/SortSelect";

import CameraFilterContext from "../../CameraListing/CameraFilterContext";
import { FILTER_TYPE } from "../../../../lib/hooks/useCameraFilter";
import t from "../../../../lib/translate";

import * as styles from "./filter.module.less";
import { Range } from "../filter-types/Range/Range";
import { FilterButton } from "../filter-types/FilterButton/FilterButton";
import { useIsTablet } from "../../../../lib/hooks/mediaQueries";

function Filter({ sectionId }) {
    const {
        filters,
        sortBy,
        addFilterOptionAction,
        removeFilterOptionAction,
        isLoading,
        items
    } = useContext(CameraFilterContext);

    const [showFilter, setShowFilter] = useState(false);
    const isTablet = useIsTablet();

    return (
        <SectionContainer
            sectionId={sectionId}
            background="bg_grey"
            containerClass={styles.filterContainer}
        >
            <div className={styles.topBar} data-datocms-noindex={true}>
                <div className={styles.leftContent}>
                    <Button
                        type="cta"
                        iconPosition={"left"}
                        icon={showFilter ? "close" : "filter"}
                        onClick={() => setShowFilter(!showFilter)}
                    >
                        {showFilter
                            ? t`camera.filter.button.hide`
                            : t`camera.filter.button.show`}
                    </Button>
                    <ResultCount key={items.map(i => i.id)} />
                </div>

                {!isTablet && sortBy && sortBy.options?.length > 0 && (
                    <SortSelect />
                )}
            </div>

            <ActiveFilterOptions />

            {showFilter && (
                <>
                    <div
                        className={styles.filterOptionsContainer}
                        data-datocms-noindex={true}
                    >
                        {filters.map(({ key, type, settings, options }) => (
                            <div key={key}>
                                {(() => {
                                    switch (type) {
                                        case FILTER_TYPE.CHECK:
                                            return (
                                                <Check
                                                    filterKey={key}
                                                    settings={settings}
                                                    options={options}
                                                    onAddFilterOption={
                                                        addFilterOptionAction
                                                    }
                                                    onRemoveFilterOption={
                                                        removeFilterOptionAction
                                                    }
                                                />
                                            );
                                        case FILTER_TYPE.BTN:
                                            return (
                                                <FilterButton
                                                    filterKey={key}
                                                    settings={settings}
                                                    options={options}
                                                />
                                            );
                                        case FILTER_TYPE.SELECT:
                                            return (
                                                <Select
                                                    filterKey={key}
                                                    settings={settings}
                                                    options={options}
                                                />
                                            );
                                        case FILTER_TYPE.RANGE:
                                            return (
                                                <Range
                                                    filterKey={key}
                                                    settings={settings}
                                                    options={options}
                                                />
                                            );
                                        default:
                                            return null;
                                    }
                                })()}
                            </div>
                        ))}
                    </div>
                    {/* Loading Overlay is shown for 300ms */}
                    {isLoading && <div className={styles.loadingOverlay} />}
                </>
            )}
            {isTablet && sortBy && sortBy.options?.length > 0 && <SortSelect />}
        </SectionContainer>
    );
}

export { Filter };
